import _flowRight from 'lodash/flowRight';
import _uniqueId from 'lodash/uniqueId';
import _uniq from 'lodash/uniq';
import { normalize } from 'normalizr';
import { getAppointment, getAppointmentByDate } from '@homeservices/api-kit/workorder/appointments';
import { APPOINTMENTS_SCHEMA } from '@/store/modules/entities';
import { withTakeLatest } from '@/utils/cancel-token';
import { withRequestLifecycle, REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';
// import http from '@homeservices/api-kit/axios';

const MUTATION_KEY = 'patchAppointments';

const emptyArray = [];

const initialPartialState = {
  status: REQUEST_LIFECYCLE.UNINITIALIZED,
  error: null,
  result: emptyArray,
  count: 0,
  total: 0,
  hasMore: false,
};
// const fetchJobId = async (order_hash) => {
//   const baseUrl = '/platform/workorder/r/workorder/prorders/order-hash-to-job-id/temporary/v1?order_hash=';
//   const { data: { results } } = await http.get(baseUrl + order_hash);
//   return results;
// };

export default {
  namespaced: true,
  state: {
    appointmentsKey: _uniqueId(),
  },
  getters: {
    appointmentsKey: state => state.appointmentsKey,
    getAppointmentsMetaByBucketName: state => (bucketName) => {
      const { result, ...meta } = state[bucketName] || initialPartialState;

      return meta;
    },
    getRawAppointmentsByBucketName: (
      state,
      _,
      __,
      { 'entities/appointments': rawAppointments }
    ) => bucketName => [...(state[bucketName] || initialPartialState).result].sort(
      (firstId, secondId) =>
        new Date(rawAppointments[firstId].start_dtm) - new Date(rawAppointments[secondId].start_dtm)
    ),
    getGroupedByDateRawAppointmentsByBucketName: (
      _,
      { getRawAppointmentsByBucketName },
      __,
      { 'entities/appointments': rawAppointments }
    ) => (bucketName) => {
      const sortedRawAppointments = getRawAppointmentsByBucketName(bucketName);

      return sortedRawAppointments.reduce((acc, appointmentId) => {
        const rawAppointment = rawAppointments[appointmentId];
        const date = new Date(addUTCTimeZoneDesignator(rawAppointment.start_dtm));

        date.setHours(0, 0, 0, 0);

        const dateGroup = date.toISOString();

        return {
          ...acc,
          [dateGroup]: [...(acc[dateGroup] || []), appointmentId],
        };
      }, {});
    },
  },
  actions: {
    fetchAppointmentsByDate: _flowRight(
      withTakeLatest(),
      withRequestLifecycle(MUTATION_KEY),
      () => async (
        { dispatch },
        {
          injected: { performFulfillment, performSideEffect },
          includeJobs,
          params = {},
        }
      ) => {
        const {
          data: { results, total },
        } = await getAppointmentByDate({
          ...params,
        });

        const orderHashes = _uniq(results.map(({ order_hash }) => order_hash)).join(',');
        // const jobIds = await fetchJobId(orderHashes);
        const resultsWithId = results.map(r => ({
          ...r,
          id: r.appointment_id,
        }));

        if (includeJobs) {
          performSideEffect(() =>
            dispatch(
              'dashboard/workOrderMatches/fetchWorkOrderMatches',
              {
                jobsStatusAlias: 'appointments',
                params: { order_hash: orderHashes },
              },
              { root: true }
            )
          );
        }

        return performFulfillment({
          total,
          ...normalize(resultsWithId, [APPOINTMENTS_SCHEMA]),
        });
      }
    )(),
    fetchAppointments: _flowRight(
      withTakeLatest(),
      withRequestLifecycle(MUTATION_KEY),
      () => async (
        { dispatch },
        {
          injected: { performFulfillment, performSideEffect },
          includeJobs,
          params = {},
        }
      ) => {
        const {
          data: { results, total },
        } = await getAppointment({
          ...params,
        });

        if (includeJobs) {
          performSideEffect(() =>
            dispatch(
              'dashboard/workOrderMatches/fetchWorkOrderMatches',
              {
                jobsStatusAlias: 'appointments',
                // params: { order_hash: orderHashes },
              },
              { root: true }
            )
          );
        }

        const resultsWithId = results.map(r => ({
          ...r,
          id: r.appointment_id,
        }));

        return performFulfillment({
          total,
          ...normalize(resultsWithId, [APPOINTMENTS_SCHEMA]),
        });
      }
    )(),
    resetAppointments: ({ commit }, { bucketName }) =>
      commit('resetAppointments', { meta: { bucketName } }),

  },

  mutations: {
    [MUTATION_KEY] (state, payload) {
      const { bucketName } = payload.meta;
      const partialState = state[bucketName] || initialPartialState;
      const result = [...new Set([...partialState.result, ...(payload.result || emptyArray)])];

      state[bucketName] = {
        ...partialState,
        ...payload,
        result,
        count: result.length,
        hasMore: result.length < payload.total,
      };

      state.appointmentsKey = _uniqueId();
    },
    resetAppointments (state, { meta }) {
      const { bucketName } = meta;

      state[bucketName] = initialPartialState;
      state[bucketName].meta = meta;

      state.appointmentsKey = _uniqueId();
    },
  },
};
